import { supabase } from '../supabaseClient';

/* Accès aux données « profiles_planning ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchProfilesPlanning() {
  return supabase
    .from('profiles_planning')
    .select('id,nom,taux_contrat,dev_id,archived_at,jours_travailles,is_planifiable,color')
    .order('id');
}
